import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '../../../core/translation';
import { operationStatus } from '../../constants/documents';
import { Routes } from '../../models/routes';
import { FinishProService } from '../../services/finish-pro.service';
import { LanguageService } from '../../services/language.service';
import { LoadingProService } from '../../services/loading-pro.service';

@Component({
  selector: 'app-signature-status',
  templateUrl: './signature-status.component.html',
  styleUrls: ['./signature-status.component.scss'],
})
export class SignatureStatusComponent implements OnInit {
  documentName: string;
  name: string;
  email: string;
  signDate: string;
  state: string;
  isPublic: boolean = true;
  numberState: number;
  titleMessage: string;
  sectionMessage: string;
  message: string;
  _transParam: boolean = false;

  constructor(
    public translate: TranslateService,
    private _finishProService: FinishProService,
    private _loadingPro: LoadingProService,
    private _languageService: LanguageService,
    private _router: Router,
    public ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isPublic = this._finishProService.isPublic;
    this._loadingPro.setLoader(false);
    if (!this._finishProService.operationDetailResponse) {
      this._finishProService.getOperationDetail(true).then(() => {
        this.getSignInformation();
        this.ref.detectChanges();
      });
    }
    this.getSignInformation();
  }

  getSignInformation(): void {
    this.documentName = this._finishProService.operationDetailResponse?.Documents[0] as string;
    this.name = this._finishProService.operationDetailResponse?.nameUser;
    this.email = this._finishProService.operationDetailResponse?.mailUser;
    this.signDate = this._finishProService.operationDetailResponse?.dateClose?.toString();
    const status: number = this._finishProService.getCurrentOperationStatus();
    this.numberState = status;
    this.state = operationStatus[status];
    this.changeTranslations();
  }

  exitProcess(): void {
    this._languageService.resetCurrentLanguage();
    this._router.navigate([Routes.DASHBOARD]);
  }

  shouldShowList(): boolean {
    return ![3, 4, 8].includes(this.numberState);
  }

  changeTranslations(): void {
    if (this.numberState) {
      if (this.numberState === 4 || this.numberState === 3) {
        this.titleMessage = this.translate.instant('signaturit_pro.signature-status.title_refused');
        this.sectionMessage = this.translate.instant('signaturit_pro.signature-status.description_refused');
      } else if (this.numberState === 8) {
        this.titleMessage = this.translate.instant('signaturit_pro.general.documents.status.blocked');
        this.sectionMessage = this.translate.instant('detallecircuito_desbloquear_info');
      } else {
        this.titleMessage = this.translate.instant('signaturit_pro.signature-status.title');
        this.sectionMessage = this.translate.instant('signaturit_pro.signature-status.description');
        this.message = this.translate.instant('signaturit_pro.signature-status.signed');
      }
    }
  }
}
